module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/User-folder-725e8334b8893c5ed7e818a68456852a.svg";